import React from 'react';
import { List, Label } from 'semantic-ui-react';
import isEmpty from 'lodash/isEmpty';
import { LocationPropType } from '../../TeamMember.types';
import './Location.css';
var defaultProps = {};
export default function Location(_ref) {
  var locations = _ref.locations;
  if (isEmpty(locations)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(List, {
    className: "location",
    horizontal: true
  }, locations.map(function (_ref2) {
    var id = _ref2._id,
      name = _ref2.name;
    return /*#__PURE__*/React.createElement(Label, {
      key: id + name
    }, name);
  }));
}
Location.defaultProps = defaultProps;